import * as React from 'react';
export var headingSectionNameContext = React.createContext('');
